import _toConsumableArray from "C:/agent/_work/3/s/LCB/Research/Content/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "C:/agent/_work/3/s/LCB/Research/Content/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _construct from "C:/agent/_work/3/s/LCB/Research/Content/node_modules/@babel/runtime/helpers/esm/construct.js";
import _createClass from "C:/agent/_work/3/s/LCB/Research/Content/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "C:/agent/_work/3/s/LCB/Research/Content/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "C:/agent/_work/3/s/LCB/Research/Content/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/agent/_work/3/s/LCB/Research/Content/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/agent/_work/3/s/LCB/Research/Content/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "C:/agent/_work/3/s/LCB/Research/Content/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "C:/agent/_work/3/s/LCB/Research/Content/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "C:/agent/_work/3/s/LCB/Research/Content/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["ref", "predicates"],
    _excluded2 = ["limit"],
    _excluded3 = ["ref", "accessToken"];
import _regeneratorRuntime from "C:\\agent\\_work\\3\\s\\LCB\\Research\\Content\\node_modules\\@babel\\runtime\\regenerator\\index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/esnext.global-this.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as prismicH from '@prismicio/helpers';

var getEndpoint = function getEndpoint(repositoryName) {
  return "https://".concat(repositoryName, ".cdn.prismic.io/api/v2");
};

var castArray = function castArray(a) {
  return Array.isArray(a) ? a : [a];
};

var RENAMED_PARAMS = {
  accessToken: "access_token"
};

var castOrderingToString = function castOrderingToString(ordering) {
  return typeof ordering === "string" ? ordering : [ordering.field, ordering.direction === "desc" ? ordering.direction : void 0].filter(Boolean).join(" ");
};

var _buildQueryURL = function buildQueryURL(endpoint, args) {
  var _a;

  var ref = args.ref,
      predicates = args.predicates,
      params = _objectWithoutProperties(args, _excluded);

  var url = new URL("documents/search", "".concat(endpoint, "/"));
  url.searchParams.set("ref", ref);

  if (predicates) {
    var _iterator = _createForOfIteratorHelper(castArray(predicates)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _predicate = _step.value;
        url.searchParams.append("q", "[".concat(_predicate, "]"));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  for (var k in params) {
    var name = (_a = RENAMED_PARAMS[k]) != null ? _a : k;
    var value = params[k];

    if (name === "orderings") {
      var scopedValue = params[name];

      if (scopedValue != null) {
        var v = castArray(scopedValue).map(function (ordering) {
          return castOrderingToString(ordering);
        }).join(",");
        value = "[".concat(v, "]");
      }
    } else if (name === "routes") {
      if (typeof params[name] === "object") {
        value = JSON.stringify(castArray(params[name]));
      }
    }

    if (value != null) {
      url.searchParams.set(name, castArray(value).join(","));
    }
  }

  return url.toString();
};

var appendPredicates = function appendPredicates() {
  for (var _len = arguments.length, predicates = new Array(_len), _key = 0; _key < _len; _key++) {
    predicates[_key] = arguments[_key];
  }

  return function () {
    var objWithPredicates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread(_objectSpread({}, objWithPredicates), {}, {
      predicates: [objWithPredicates.predicates || []].concat(predicates).flat()
    });
  };
};

var readValue = function readValue(value) {
  return value.replace(/%3B/g, ";");
};

var parse = function parse(cookieString) {
  var result = {};
  var cookies = cookieString.split("; ");

  var _iterator2 = _createForOfIteratorHelper(cookies),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _cookie = _step2.value;

      var parts = _cookie.split("=");

      var value = parts.slice(1).join("=");
      var name = readValue(parts[0]).replace(/%3D/g, "=");
      result[name] = readValue(value);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return result;
};

var getAll = function getAll(cookieStore) {
  return parse(cookieStore);
};

var getCookie = function getCookie(name, cookieStore) {
  return getAll(cookieStore)[name];
};

var isForbiddenErrorAPIResponse = function isForbiddenErrorAPIResponse(input) {
  return typeof input === "object" && input !== null && ("error" in input || "message" in input) && "oauth_initiate" in input && "oauth_token" in input;
};

var ForbiddenError = /*#__PURE__*/function (_Error) {
  _inherits(ForbiddenError, _Error);

  var _super = _createSuper(ForbiddenError);

  function ForbiddenError(message, args) {
    var _this;

    _classCallCheck(this, ForbiddenError);

    _this = _super.call(this, message);
    _this.url = args.url;
    _this.oauth_initiate = args.response.oauth_initiate;
    _this.oauth_token = args.response.oauth_token;
    return _this;
  }

  return _createClass(ForbiddenError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var isParsingErrorAPIResponse = function isParsingErrorAPIResponse(input) {
  return typeof input === "object" && input !== null && "message" in input && "type" in input;
};

var ParsingError = /*#__PURE__*/function (_Error2) {
  _inherits(ParsingError, _Error2);

  var _super2 = _createSuper(ParsingError);

  function ParsingError(message, args) {
    var _this2;

    _classCallCheck(this, ParsingError);

    _this2 = _super2.call(this, message);
    _this2.url = args.url;
    _this2.line = args.response.line;
    _this2.column = args.response.column;
    _this2.id = args.response.id;
    _this2.location = args.response.location;
    return _this2;
  }

  return _createClass(ParsingError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var PrismicError = /*#__PURE__*/function (_Error3) {
  _inherits(PrismicError, _Error3);

  var _super3 = _createSuper(PrismicError);

  function PrismicError(message, args) {
    var _this3;

    _classCallCheck(this, PrismicError);

    _this3 = _super3.call(this, message || "An invalid API response was returned");
    _this3.url = args.url;
    _this3.response = args.response;
    return _this3;
  }

  return _createClass(PrismicError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var preview = "io.prismic.preview";
var cookie = /*#__PURE__*/Object.freeze({
  __proto__: null,
  preview: preview
});

var formatValue = function formatValue(value) {
  if (Array.isArray(value)) {
    return "[".concat(value.map(formatValue).join(", "), "]");
  }

  if (typeof value === "string") {
    return "\"".concat(value, "\"");
  }

  if (value instanceof Date) {
    return "".concat(value.getTime());
  }

  return "".concat(value);
};

var pathWithArgsPredicate = function pathWithArgsPredicate(name) {
  var fn = function fn(path) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var formattedArgs = args.map(formatValue).join(", ");
    var joiner = path && args.length ? ", " : "";
    return "[".concat(name, "(").concat(path).concat(joiner).concat(formattedArgs, ")]");
  };

  return fn;
};

var pathPredicate = function pathPredicate(name) {
  var predicateFn = pathWithArgsPredicate(name);

  var fn = function fn(path) {
    return predicateFn(path);
  };

  return fn;
};

var argsPredicate = function argsPredicate(name) {
  var predicateFn = pathWithArgsPredicate(name);

  var fn = function fn() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return predicateFn.apply(void 0, [""].concat(args));
  };

  return fn;
};

var at = pathWithArgsPredicate("at");
var not = pathWithArgsPredicate("not");
var any = pathWithArgsPredicate("any");

var _in = pathWithArgsPredicate("in");

var fulltext = pathWithArgsPredicate("fulltext");
var has = pathPredicate("has");
var missing = pathPredicate("missing");
var similar = argsPredicate("similar");
var geopointNear = pathWithArgsPredicate("geopoint.near");
var numberLessThan = pathWithArgsPredicate("number.lt");
var numberGreaterThan = pathWithArgsPredicate("number.gt");
var numberInRange = pathWithArgsPredicate("number.inRange");
var dateAfter = pathWithArgsPredicate("date.after");
var dateBefore = pathWithArgsPredicate("date.before");
var dateBetween = pathWithArgsPredicate("date.between");
var dateDayOfMonth = pathWithArgsPredicate("date.day-of-month");
var dateDayOfMonthAfter = pathWithArgsPredicate("date.day-of-month-after");
var dateDayOfMonthBefore = pathWithArgsPredicate("date.day-of-month-before");
var dateDayOfWeek = pathWithArgsPredicate("date.day-of-week");
var dateDayOfWeekAfter = pathWithArgsPredicate("date.day-of-week-after");
var dateDayOfWeekBefore = pathWithArgsPredicate("date.day-of-week-before");
var dateMonth = pathWithArgsPredicate("date.month");
var dateMonthAfter = pathWithArgsPredicate("date.month-after");
var dateMonthBefore = pathWithArgsPredicate("date.month-before");
var dateYear = pathWithArgsPredicate("date.year");
var dateHour = pathWithArgsPredicate("date.hour");
var dateHourAfter = pathWithArgsPredicate("date.hour-after");
var dateHourBefore = pathWithArgsPredicate("date.hour-before");
var predicate = /*#__PURE__*/Object.freeze({
  __proto__: null,
  at: at,
  not: not,
  any: any,
  'in': _in,
  fulltext: fulltext,
  has: has,
  missing: missing,
  similar: similar,
  geopointNear: geopointNear,
  numberLessThan: numberLessThan,
  numberGreaterThan: numberGreaterThan,
  numberInRange: numberInRange,
  dateAfter: dateAfter,
  dateBefore: dateBefore,
  dateBetween: dateBetween,
  dateDayOfMonth: dateDayOfMonth,
  dateDayOfMonthAfter: dateDayOfMonthAfter,
  dateDayOfMonthBefore: dateDayOfMonthBefore,
  dateDayOfWeek: dateDayOfWeek,
  dateDayOfWeekAfter: dateDayOfWeekAfter,
  dateDayOfWeekBefore: dateDayOfWeekBefore,
  dateMonth: dateMonth,
  dateMonthAfter: dateMonthAfter,
  dateMonthBefore: dateMonthBefore,
  dateYear: dateYear,
  dateHour: dateHour,
  dateHourAfter: dateHourAfter,
  dateHourBefore: dateHourBefore
});

var createSimpleTTLCache = function createSimpleTTLCache() {
  var cache = new Map();
  return {
    get: function get(key) {
      var cacheValue = cache.get(key);

      if (cacheValue) {
        if (new Date().getTime() < cacheValue.expiresAt) {
          return cacheValue.value;
        }
      }
    },
    set: function set(key, value, ttl) {
      cache.set(key, {
        expiresAt: new Date().getTime() + ttl,
        value: value
      });
    }
  };
};

var MAX_PAGE_SIZE = 100;
var REPOSITORY_CACHE_TTL = 5e3;
var RefStateType;

(function (RefStateType2) {
  RefStateType2[RefStateType2["Master"] = 0] = "Master";
  RefStateType2[RefStateType2["ReleaseByID"] = 1] = "ReleaseByID";
  RefStateType2[RefStateType2["ReleaseByLabel"] = 2] = "ReleaseByLabel";
  RefStateType2[RefStateType2["Manual"] = 3] = "Manual";
})(RefStateType || (RefStateType = {}));

var typePredicate = function typePredicate(documentType) {
  return at("document.type", documentType);
};

var tagsPredicate = function tagsPredicate(tags) {
  return at("document.tags", tags);
};

var findRef = function findRef(refs, predicate2) {
  var ref = refs.find(function (ref2) {
    return predicate2(ref2);
  });

  if (!ref) {
    throw new Error("Ref could not be found.");
  }

  return ref;
};

var createClient = function createClient() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return _construct(Client, args);
};

var Client = /*#__PURE__*/function () {
  function Client(endpoint) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Client);

    this.query = this.get.bind(this);
    this.endpoint = endpoint;
    this.accessToken = options.accessToken;
    this.defaultParams = options.defaultParams;
    this.internalCache = createSimpleTTLCache();
    this.refMode = {
      type: 0,
      autoPreviewsEnabled: true
    };

    if (options.ref) {
      this.queryContentFromRef(options.ref);
    }

    if (typeof options.fetch === "function") {
      this.fetchFn = options.fetch;
    } else if (typeof globalThis.fetch === "function") {
      this.fetchFn = globalThis.fetch;
    } else {
      throw new Error("A valid fetch implementation was not provided. In environments where fetch is not available (including Node.js), a fetch implementation must be provided via a polyfill or the `fetch` option.");
    }

    if (this.fetchFn === globalThis.fetch) {
      this.fetchFn = this.fetchFn.bind(globalThis);
    }
  }

  _createClass(Client, [{
    key: "enableAutoPreviews",
    value: function enableAutoPreviews() {
      this.refMode.autoPreviewsEnabled = true;
    }
  }, {
    key: "enableAutoPreviewsFromReq",
    value: function enableAutoPreviewsFromReq(req) {
      this.refMode.httpRequest = req;
      this.refMode.autoPreviewsEnabled = true;
    }
  }, {
    key: "disableAutoPreviews",
    value: function disableAutoPreviews() {
      this.refMode.autoPreviewsEnabled = false;
    }
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.buildQueryURL(params);

              case 2:
                url = _context.sent;
                _context.next = 5;
                return this.fetch(url);

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getFirst",
    value: function () {
      var _getFirst = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        var result, firstResult;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.get(params);

              case 2:
                result = _context2.sent;
                firstResult = result.results[0];

                if (!firstResult) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", firstResult);

              case 6:
                throw new Error("No documents were returned");

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getFirst(_x2) {
        return _getFirst.apply(this, arguments);
      }

      return getFirst;
    }()
  }, {
    key: "getAll",
    value: function () {
      var _getAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var params,
            _params$limit,
            limit,
            actualParams,
            resolvedParams,
            result,
            page,
            documents,
            result2,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                _params$limit = params.limit, limit = _params$limit === void 0 ? Infinity : _params$limit, actualParams = _objectWithoutProperties(params, _excluded2);
                resolvedParams = _objectSpread({
                  pageSize: MAX_PAGE_SIZE
                }, actualParams);
                _context3.next = 5;
                return this.get(resolvedParams);

              case 5:
                result = _context3.sent;
                page = result.page;
                documents = result.results;

              case 8:
                if (!(page < result.total_pages && documents.length < limit)) {
                  _context3.next = 16;
                  break;
                }

                page += 1;
                _context3.next = 12;
                return this.get(_objectSpread(_objectSpread({}, resolvedParams), {}, {
                  page: page
                }));

              case 12:
                result2 = _context3.sent;
                documents = [].concat(_toConsumableArray(documents), _toConsumableArray(result2.results));
                _context3.next = 8;
                break;

              case 16:
                return _context3.abrupt("return", documents.slice(0, limit));

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAll() {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getByID",
    value: function () {
      var _getByID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, params) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getFirst(appendPredicates(at("document.id", id))(params));

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getByID(_x3, _x4) {
        return _getByID.apply(this, arguments);
      }

      return getByID;
    }()
  }, {
    key: "getByIDs",
    value: function () {
      var _getByIDs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(ids, params) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.get(appendPredicates(_in("document.id", ids))(params));

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getByIDs(_x5, _x6) {
        return _getByIDs.apply(this, arguments);
      }

      return getByIDs;
    }()
  }, {
    key: "getAllByIDs",
    value: function () {
      var _getAllByIDs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(ids, params) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.getAll(appendPredicates(_in("document.id", ids))(params));

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getAllByIDs(_x7, _x8) {
        return _getAllByIDs.apply(this, arguments);
      }

      return getAllByIDs;
    }()
  }, {
    key: "getByUID",
    value: function () {
      var _getByUID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(documentType, uid, params) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getFirst(appendPredicates(typePredicate(documentType), at("my.".concat(documentType, ".uid"), uid))(params));

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getByUID(_x9, _x10, _x11) {
        return _getByUID.apply(this, arguments);
      }

      return getByUID;
    }()
  }, {
    key: "getSingle",
    value: function () {
      var _getSingle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(documentType, params) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.getFirst(appendPredicates(typePredicate(documentType))(params));

              case 2:
                return _context8.abrupt("return", _context8.sent);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getSingle(_x12, _x13) {
        return _getSingle.apply(this, arguments);
      }

      return getSingle;
    }()
  }, {
    key: "getByType",
    value: function () {
      var _getByType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(documentType, params) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.get(appendPredicates(typePredicate(documentType))(params));

              case 2:
                return _context9.abrupt("return", _context9.sent);

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getByType(_x14, _x15) {
        return _getByType.apply(this, arguments);
      }

      return getByType;
    }()
  }, {
    key: "getAllByType",
    value: function () {
      var _getAllByType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(documentType, params) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.getAll(appendPredicates(typePredicate(documentType))(params));

              case 2:
                return _context10.abrupt("return", _context10.sent);

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getAllByType(_x16, _x17) {
        return _getAllByType.apply(this, arguments);
      }

      return getAllByType;
    }()
  }, {
    key: "getByTag",
    value: function () {
      var _getByTag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(tag, params) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.get(appendPredicates(tagsPredicate(tag))(params));

              case 2:
                return _context11.abrupt("return", _context11.sent);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getByTag(_x18, _x19) {
        return _getByTag.apply(this, arguments);
      }

      return getByTag;
    }()
  }, {
    key: "getAllByTag",
    value: function () {
      var _getAllByTag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(tag, params) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.getAll(appendPredicates(tagsPredicate(tag))(params));

              case 2:
                return _context12.abrupt("return", _context12.sent);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getAllByTag(_x20, _x21) {
        return _getAllByTag.apply(this, arguments);
      }

      return getAllByTag;
    }()
  }, {
    key: "getByTags",
    value: function () {
      var _getByTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(tags, params) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.get(appendPredicates(tagsPredicate(tags))(params));

              case 2:
                return _context13.abrupt("return", _context13.sent);

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getByTags(_x22, _x23) {
        return _getByTags.apply(this, arguments);
      }

      return getByTags;
    }()
  }, {
    key: "getAllByTags",
    value: function () {
      var _getAllByTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(tags, params) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.getAll(appendPredicates(tagsPredicate(tags))(params));

              case 2:
                return _context14.abrupt("return", _context14.sent);

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getAllByTags(_x24, _x25) {
        return _getAllByTags.apply(this, arguments);
      }

      return getAllByTags;
    }()
  }, {
    key: "getRepository",
    value: function () {
      var _getRepository = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var url;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                url = new URL(this.endpoint);

                if (this.accessToken) {
                  url.searchParams.set("access_token", this.accessToken);
                }

                _context15.next = 4;
                return this.fetch(url.toString());

              case 4:
                return _context15.abrupt("return", _context15.sent);

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function getRepository() {
        return _getRepository.apply(this, arguments);
      }

      return getRepository;
    }()
  }, {
    key: "getRefs",
    value: function () {
      var _getRefs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var res;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.getRepository();

              case 2:
                res = _context16.sent;
                return _context16.abrupt("return", res.refs);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function getRefs() {
        return _getRefs.apply(this, arguments);
      }

      return getRefs;
    }()
  }, {
    key: "getRefById",
    value: function () {
      var _getRefById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(id) {
        var refs;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.getRefs();

              case 2:
                refs = _context17.sent;
                return _context17.abrupt("return", findRef(refs, function (ref) {
                  return ref.id === id;
                }));

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getRefById(_x26) {
        return _getRefById.apply(this, arguments);
      }

      return getRefById;
    }()
  }, {
    key: "getRefByLabel",
    value: function () {
      var _getRefByLabel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(label) {
        var refs;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.getRefs();

              case 2:
                refs = _context18.sent;
                return _context18.abrupt("return", findRef(refs, function (ref) {
                  return ref.label === label;
                }));

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getRefByLabel(_x27) {
        return _getRefByLabel.apply(this, arguments);
      }

      return getRefByLabel;
    }()
  }, {
    key: "getMasterRef",
    value: function () {
      var _getMasterRef = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var refs;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.getRefs();

              case 2:
                refs = _context19.sent;
                return _context19.abrupt("return", findRef(refs, function (ref) {
                  return ref.isMasterRef;
                }));

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getMasterRef() {
        return _getMasterRef.apply(this, arguments);
      }

      return getMasterRef;
    }()
  }, {
    key: "getReleases",
    value: function () {
      var _getReleases = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var refs;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.getRefs();

              case 2:
                refs = _context20.sent;
                return _context20.abrupt("return", refs.filter(function (ref) {
                  return !ref.isMasterRef;
                }));

              case 4:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getReleases() {
        return _getReleases.apply(this, arguments);
      }

      return getReleases;
    }()
  }, {
    key: "getReleaseByID",
    value: function () {
      var _getReleaseByID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(id) {
        var releases;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.getReleases();

              case 2:
                releases = _context21.sent;
                return _context21.abrupt("return", findRef(releases, function (ref) {
                  return ref.id === id;
                }));

              case 4:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getReleaseByID(_x28) {
        return _getReleaseByID.apply(this, arguments);
      }

      return getReleaseByID;
    }()
  }, {
    key: "getReleaseByLabel",
    value: function () {
      var _getReleaseByLabel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(label) {
        var releases;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.getReleases();

              case 2:
                releases = _context22.sent;
                return _context22.abrupt("return", findRef(releases, function (ref) {
                  return ref.label === label;
                }));

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function getReleaseByLabel(_x29) {
        return _getReleaseByLabel.apply(this, arguments);
      }

      return getReleaseByLabel;
    }()
  }, {
    key: "getTags",
    value: function () {
      var _getTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var tagsForm, res;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;
                _context23.next = 3;
                return this.getCachedRepositoryForm("tags");

              case 3:
                tagsForm = _context23.sent;
                _context23.next = 6;
                return this.fetch(tagsForm.action);

              case 6:
                return _context23.abrupt("return", _context23.sent);

              case 9:
                _context23.prev = 9;
                _context23.t0 = _context23["catch"](0);
                _context23.next = 13;
                return this.getRepository();

              case 13:
                res = _context23.sent;
                return _context23.abrupt("return", res.tags);

              case 15:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[0, 9]]);
      }));

      function getTags() {
        return _getTags.apply(this, arguments);
      }

      return getTags;
    }()
  }, {
    key: "buildQueryURL",
    value: function () {
      var _buildQueryURL2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var params,
            _params$ref,
            ref,
            _params$accessToken,
            accessToken,
            actualParams,
            _args24 = arguments;

        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                params = _args24.length > 0 && _args24[0] !== undefined ? _args24[0] : {};
                _params$ref = params.ref;

                if (!(_params$ref === void 0)) {
                  _context24.next = 8;
                  break;
                }

                _context24.next = 5;
                return this.getResolvedRefString();

              case 5:
                _context24.t0 = _context24.sent;
                _context24.next = 9;
                break;

              case 8:
                _context24.t0 = _params$ref;

              case 9:
                ref = _context24.t0;
                _params$accessToken = params.accessToken;
                accessToken = _params$accessToken === void 0 ? this.accessToken : _params$accessToken;
                actualParams = _objectWithoutProperties(params, _excluded3);
                return _context24.abrupt("return", _buildQueryURL(this.endpoint, _objectSpread(_objectSpread(_objectSpread({}, this.defaultParams), actualParams), {}, {
                  accessToken: accessToken,
                  ref: ref
                })));

              case 14:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function buildQueryURL() {
        return _buildQueryURL2.apply(this, arguments);
      }

      return buildQueryURL;
    }()
  }, {
    key: "resolvePreviewURL",
    value: function () {
      var _resolvePreviewURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(args) {
        var _a, documentId, previewToken, searchParams, document;

        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                documentId = args.documentId;
                previewToken = args.previewToken;

                if (typeof globalThis.location !== "undefined") {
                  searchParams = new URLSearchParams(globalThis.location.search);
                  documentId = documentId || searchParams.get("documentId") || void 0;
                  previewToken = previewToken || searchParams.get("token") || void 0;
                } else if ((_a = this.refMode.httpRequest) == null ? void 0 : _a.query) {
                  if (typeof this.refMode.httpRequest.query.documentId === "string") {
                    documentId = documentId || this.refMode.httpRequest.query.documentId;
                  }

                  if (typeof this.refMode.httpRequest.query.token === "string") {
                    previewToken = previewToken || this.refMode.httpRequest.query.token;
                  }
                }

                if (!(documentId != null)) {
                  _context25.next = 10;
                  break;
                }

                _context25.next = 6;
                return this.getByID(documentId, {
                  ref: previewToken
                });

              case 6:
                document = _context25.sent;
                return _context25.abrupt("return", prismicH.asLink(prismicH.documentToLinkField(document), args.linkResolver));

              case 10:
                return _context25.abrupt("return", args.defaultURL);

              case 11:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function resolvePreviewURL(_x30) {
        return _resolvePreviewURL.apply(this, arguments);
      }

      return resolvePreviewURL;
    }()
  }, {
    key: "queryLatestContent",
    value: function queryLatestContent() {
      this.refMode = _objectSpread(_objectSpread({}, this.refMode), {}, {
        type: 0
      });
    }
  }, {
    key: "queryContentFromReleaseByID",
    value: function queryContentFromReleaseByID(releaseId) {
      this.refMode = _objectSpread(_objectSpread({}, this.refMode), {}, {
        type: 1,
        payload: {
          releaseId: releaseId
        }
      });
    }
  }, {
    key: "queryContentFromReleaseByLabel",
    value: function queryContentFromReleaseByLabel(releaseLabel) {
      this.refMode = _objectSpread(_objectSpread({}, this.refMode), {}, {
        type: 2,
        payload: {
          releaseLabel: releaseLabel
        }
      });
    }
  }, {
    key: "queryContentFromRef",
    value: function queryContentFromRef(ref) {
      this.refMode = _objectSpread(_objectSpread({}, this.refMode), {}, {
        type: 3,
        payload: {
          refStringOrFn: ref
        }
      });
    }
  }, {
    key: "getCachedRepository",
    value: function () {
      var _getCachedRepository = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var cacheKey, cachedRepository, repository;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                cacheKey = this.endpoint;
                cachedRepository = this.internalCache.get(cacheKey);

                if (!cachedRepository) {
                  _context26.next = 4;
                  break;
                }

                return _context26.abrupt("return", cachedRepository);

              case 4:
                _context26.next = 6;
                return this.getRepository();

              case 6:
                repository = _context26.sent;
                this.internalCache.set(cacheKey, repository, REPOSITORY_CACHE_TTL);
                return _context26.abrupt("return", repository);

              case 9:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function getCachedRepository() {
        return _getCachedRepository.apply(this, arguments);
      }

      return getCachedRepository;
    }()
  }, {
    key: "getCachedRepositoryForm",
    value: function () {
      var _getCachedRepositoryForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(name) {
        var cachedRepository, form;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.getCachedRepository();

              case 2:
                cachedRepository = _context27.sent;
                form = cachedRepository.forms[name];

                if (form) {
                  _context27.next = 6;
                  break;
                }

                throw new Error("Form with name \"".concat(name, "\" could not be found"));

              case 6:
                return _context27.abrupt("return", form);

              case 7:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function getCachedRepositoryForm(_x31) {
        return _getCachedRepositoryForm.apply(this, arguments);
      }

      return getCachedRepositoryForm;
    }()
  }, {
    key: "getPreviewRefString",
    value: function getPreviewRefString() {
      var _a, _b, _c;

      if ((_a = globalThis.document) == null ? void 0 : _a.cookie) {
        return getCookie(preview, globalThis.document.cookie);
      } else if ((_c = (_b = this.refMode.httpRequest) == null ? void 0 : _b.headers) == null ? void 0 : _c.cookie) {
        return getCookie(preview, this.refMode.httpRequest.headers.cookie);
      }
    }
  }, {
    key: "getResolvedRefString",
    value: function () {
      var _getResolvedRefString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        var previewRef, releaseId, repository, ref, releaseLabel, _repository, _ref, thisRefStringOrFn, res, _repository2, _ref2;

        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                if (!this.refMode.autoPreviewsEnabled) {
                  _context28.next = 4;
                  break;
                }

                previewRef = this.getPreviewRefString();

                if (!previewRef) {
                  _context28.next = 4;
                  break;
                }

                return _context28.abrupt("return", previewRef);

              case 4:
                _context28.t0 = this.refMode.type;
                _context28.next = _context28.t0 === 1 ? 7 : _context28.t0 === 2 ? 13 : _context28.t0 === 3 ? 19 : _context28.t0 === 0 ? 30 : 30;
                break;

              case 7:
                releaseId = this.refMode.payload.releaseId;
                _context28.next = 10;
                return this.getCachedRepository();

              case 10:
                repository = _context28.sent;
                ref = findRef(repository.refs, function (ref2) {
                  return ref2.id === releaseId;
                });
                return _context28.abrupt("return", ref.ref);

              case 13:
                releaseLabel = this.refMode.payload.releaseLabel;
                _context28.next = 16;
                return this.getCachedRepository();

              case 16:
                _repository = _context28.sent;
                _ref = findRef(_repository.refs, function (ref2) {
                  return ref2.label === releaseLabel;
                });
                return _context28.abrupt("return", _ref.ref);

              case 19:
                thisRefStringOrFn = this.refMode.payload.refStringOrFn;

                if (!(typeof thisRefStringOrFn === "function")) {
                  _context28.next = 28;
                  break;
                }

                _context28.next = 23;
                return thisRefStringOrFn();

              case 23:
                res = _context28.sent;

                if (!(typeof res === "string")) {
                  _context28.next = 26;
                  break;
                }

                return _context28.abrupt("return", res);

              case 26:
                _context28.next = 30;
                break;

              case 28:
                if (!thisRefStringOrFn) {
                  _context28.next = 30;
                  break;
                }

                return _context28.abrupt("return", thisRefStringOrFn);

              case 30:
                _context28.next = 32;
                return this.getCachedRepository();

              case 32:
                _repository2 = _context28.sent;
                _ref2 = findRef(_repository2.refs, function (ref2) {
                  return ref2.isMasterRef;
                });
                return _context28.abrupt("return", _ref2.ref);

              case 35:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function getResolvedRefString() {
        return _getResolvedRefString.apply(this, arguments);
      }

      return getResolvedRefString;
    }()
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(url) {
        var res, json;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return this.fetchFn(url);

              case 2:
                res = _context29.sent;
                _context29.prev = 3;
                _context29.next = 6;
                return res.json();

              case 6:
                json = _context29.sent;
                _context29.next = 12;
                break;

              case 9:
                _context29.prev = 9;
                _context29.t0 = _context29["catch"](3);
                throw new PrismicError(void 0, {
                  url: url
                });

              case 12:
                _context29.t1 = res.status;
                _context29.next = _context29.t1 === 200 ? 15 : _context29.t1 === 400 ? 16 : _context29.t1 === 401 ? 19 : _context29.t1 === 403 ? 19 : 21;
                break;

              case 15:
                return _context29.abrupt("return", json);

              case 16:
                if (!isParsingErrorAPIResponse(json)) {
                  _context29.next = 18;
                  break;
                }

                throw new ParsingError(json.message, {
                  url: url,
                  response: json
                });

              case 18:
                return _context29.abrupt("break", 21);

              case 19:
                if (!isForbiddenErrorAPIResponse(json)) {
                  _context29.next = 21;
                  break;
                }

                throw new ForbiddenError("error" in json ? json.error : json.message, {
                  url: url,
                  response: json
                });

              case 21:
                throw new PrismicError(void 0, {
                  url: url,
                  response: json
                });

              case 22:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this, [[3, 9]]);
      }));

      function fetch(_x32) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }]);

  return Client;
}();

export { Client, ForbiddenError, ParsingError, PrismicError, _buildQueryURL as buildQueryURL, cookie, createClient, getEndpoint, predicate };